/* eslint-disable */
import { PluginContainerData, Media } from './common';
const baseAudioData = {};
export const AudioData = {
    fromJSON(object) {
        const message = Object.assign({}, baseAudioData);
        message.containerData =
            object.containerData !== undefined && object.containerData !== null
                ? PluginContainerData.fromJSON(object.containerData)
                : undefined;
        message.audio =
            object.audio !== undefined && object.audio !== null
                ? Media.fromJSON(object.audio)
                : undefined;
        message.disableDownload =
            object.disableDownload !== undefined && object.disableDownload !== null
                ? Boolean(object.disableDownload)
                : undefined;
        message.coverImage =
            object.coverImage !== undefined && object.coverImage !== null
                ? Media.fromJSON(object.coverImage)
                : undefined;
        message.name =
            object.name !== undefined && object.name !== null ? String(object.name) : undefined;
        message.authorName =
            object.authorName !== undefined && object.authorName !== null
                ? String(object.authorName)
                : undefined;
        message.html =
            object.html !== undefined && object.html !== null ? String(object.html) : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.containerData !== undefined &&
            (obj.containerData = message.containerData
                ? PluginContainerData.toJSON(message.containerData)
                : undefined);
        message.audio !== undefined &&
            (obj.audio = message.audio ? Media.toJSON(message.audio) : undefined);
        message.disableDownload !== undefined && (obj.disableDownload = message.disableDownload);
        message.coverImage !== undefined &&
            (obj.coverImage = message.coverImage ? Media.toJSON(message.coverImage) : undefined);
        message.name !== undefined && (obj.name = message.name);
        message.authorName !== undefined && (obj.authorName = message.authorName);
        message.html !== undefined && (obj.html = message.html);
        return obj;
    },
};
//# sourceMappingURL=plugin_audio.js.map